module.exports = __webpack_public_path__ + "img/logo-mono.424f5577.svg";